function setCurrentAccountType(state, val) {
  state.currentAccountType = val;
}

export default {
  setCurrentAccountType
};
